<ebb-traning-app-page></ebb-traning-app-page>